(function($) {
    window.App = {
        ui : {
            w: $(window),
            b: $('body'),
            h: $('.pageHeader'),
            f: $('.pageFooter'),
            drawer: $('.drawer'),
            nav: $('.pageNav'),
            navPanel: $('.navPanel'),
            gotop: $('.scrollTop')
        },

        mobileCheck: function() {
            var isMobile = {
                Android: function() {
                    return navigator.userAgent.match(/Android/i);
                },
                BlackBerry: function() {
                    return navigator.userAgent.match(/BlackBerry/i);
                },
                iOS: function() {
                    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
                },
                Opera: function() {
                    return navigator.userAgent.match(/Opera Mini/i);
                },
                Windows: function() {
                    return navigator.userAgent.match(/IEMobile/i);
                },
                any: function() {
                    return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
                }
            };

            return isMobile.any();
        },

        state: {
            headerHeight: null,
            popup: null,
            timer: null,
            scrolling: false,
            navTimer: null,
            drawerTimer: null
        },

        header: function() {
            let self = this;

            let debounced = _.debounce(function () {
                let vh = window.innerHeight * 0.01;
                self.state.headerHeight = self.ui.h.outerHeight();
                document.documentElement.style.setProperty('--vh', `${vh}px`);
            }, 100);

            debounced();
            $(window).on('resize orientationchange', debounced);

            // bubble current class from sub-menu to menu
            $('.sub-menu .current-menu-item').parents('li').addClass('current-menu-item');
        },

        drawer: function () {
            let self = this;
            let drawer = $('.drawer');
            let drawerContainer = self.ui.drawer.find('.drawer__wrap');
            let drawerItems = self.ui.drawer.find('.drawer__item');

            function openDrawer(tgt) {
                self.ui.b.addClass('is-draweropen is-navunsticked');
                drawerItems.removeClass('active');
                tgt.addClass('active');
                setHeight(tgt);
            }

            function setHeight(tgt) {
                drawerContainer.css({
                    height: tgt.height()
                });
            }

            function closeDrawer() {
                self.ui.b.removeClass('is-draweropen');
                drawerItems.removeClass('active');
                self.ui.h.find('.active').removeClass('active');

                clearTimeout(self.state.timer);
                self.state.timer = setTimeout(function () {
                    self.ui.b.removeClass('is-navunsticked');
                }, 500);
            }

            $('.js-drawer-open')
            .on('click', function (e) {
                e.preventDefault();

                let me = $(this);
                let tgt = self.ui.drawer.find('.' + me.data('target'));
                if (! tgt.length) return;

                if (me.hasClass('active')) {
                    closeDrawer(tgt);
                    return;
                } else {
                    self.ui.h.find('.active').removeClass('active');
                    me.addClass('active');
                }

                if (self.ui.w.scrollTop() < 100) {
                    openDrawer(tgt);
                } else {
                    self.goTop(function () {
                        openDrawer(tgt);
                    });
                }
            })
            .on('mouseenter', function() {
                if (self.ui.w.width() < 1200) return;

                let me = $(this);
                clearTimeout(self.ui.drawerTimer);
                self.ui.drawerTimer = setTimeout(function() {
                    me.trigger('click');
                }, 500);
            })
            .on('mouseleave', function() {
                clearTimeout(self.ui.drawerTimer);
            });

            $('.js-drawer-close').on('click', function (e) {
                e.preventDefault();
                closeDrawer();
            });
        },

        nav: function() {
            let self = this;
            let panel = $('.navPanel'),
                panelItems = panel.find('.navPanel__item'),
                panelBgs = panel.find('.navPanel__bgc img'),
                panelOpen = $('.js-panelopen');

            function lazyloadPanelImgs() {
                if (panel.hasClass('loaded')) return;

                panel.addClass('loded');
                panelBgs.each(function () {
                    let me = $(this);
                    if (me.hasClass('loaded')) return;

                    me.addClass('loaded');
                    me.attr('src', me.data('src'));
                });
            }

            // submenu - toggle
            $('.js-submenu').on('click', function (e) {
                e.preventDefault();

                if (self.ui.w.width() < 1200) {
                    $(this).next('.sub-menu').slideToggle();
                }
            });

            panelOpen
            .on('mouseenter', function (e) {
                if (self.ui.w.width() < 1200) return;

                clearTimeout(self.state.navTimer);
                self.state.navTimer = setTimeout(function() {
                    self.ui.b.addClass('is-panelopen');
                    $(this).parent().addClass('current-menu-item');
                    lazyloadPanelImgs();
                }, 100);
            })
            .on('mouseleave', function() {
                clearTimeout(self.state.navTimer);
                self.state.navTimer = setTimeout(function() {
                    self.ui.b.removeClass('is-panelopen');
                    $(this).parent().removeClass('current-menu-item');
                }, 250);
            });

            $('.navPanel')
            .on('mouseenter', function() {
                clearTimeout(self.state.navTimer);
            })
            .on('mouseleave', function() {
                clearTimeout(self.state.navTimer);
                self.state.navTimer = setTimeout(function() {
                    self.ui.b.removeClass('is-panelopen');
                }, 10);
            });

            // switch image in panel on items hover
            panelItems.on('mouseenter', function () {
                let tgt = $(this).data('bg');
                console.log(tgt);
                panelBgs.removeClass('visible');
                panelBgs.filter('#' + tgt).addClass('visible');
            });

            // gotop arrow
            let gotop = _.throttle(function() {
                let st = self.ui.w.scrollTop();

                if (st > 250 && ! self.ui.b.hasClass('gotop-visible')) {
                    self.ui.b.addClass('gotop-visible');
                }
                if (st <= 250 && self.ui.b.hasClass('gotop-visible')) {
                    self.ui.b.removeClass('gotop-visible');
                }
            }, 200);

            gotop();
            self.ui.w.on('scroll', gotop);

            self.ui.gotop.on('click', function (e) {
                e.preventDefault();
                $('body, html').stop().animate({
                    scrollTop: 0
                }, 1000, 'easeInOutExpo');
            });
        },

        imitLocalmenu: function () {
            if (! window._amc_imitlocalmenu) return;

            var self = this;
            var panelwrap = $('.imitLocalmenuWrap'),
                panel = $('.headermsg');
            console.log(panelwrap);

            // stick/unstick menu
            panelwrap.waypoint(function (direction) {
                if (direction == 'down') {
                    let ph = panel.outerHeight();
                    panelwrap.css('height', ph);
                    self.ui.b.addClass('is_imitlocalmenusticked');
                } else {
                    self.ui.b.removeClass('is_imitlocalmenusticked');
                    panelwrap.css('height', 'auto');
                }
            });
        },

        localmenu: function() {
            if (! window._amc_localmenu) return;

            var self = this;
            var items = $('.waypoint'),
                panel = $('.localMenu'),
                panelwrap = $('.localMenuWrap'),
                submenus = panel.find('a'),
                firstId = items.eq(0).attr('id');

            if (! items.length) return;

            let switchCurrent = function(id) {
                submenus.removeClass('current');
                submenus.filter('[href="#' + id + '"]').addClass('current');
            }

            let switchOff = function () {
                submenus.removeClass('current');
            }

            // stick/unstick menu
            panelwrap.waypoint(function (direction) {
                if (direction == 'down') {
                    let ph = panel.outerHeight();
                    panelwrap.css('height', ph);
                    self.ui.b.addClass('is_localmenusticked');
                } else {
                    self.ui.b.removeClass('is_localmenusticked');
                    panelwrap.css('height', 'auto');
                }
            });

            // waypoints
            items.waypoint(function(direction) {
                if (self.state.scrolling) return;

                if (direction == 'up' && this.element.id == firstId) {
                    switchOff();
                } else {
                    switchCurrent(this.element.id);
                }
            }, {
                offset: 150
            });

            // scroll to waypoint on menu click
            submenus.on('click', function (e) {
                e.preventDefault();
                let me = $(this);
                let id = me.attr('href');
                let tgt = $(id);

                self.state.scrolling = true;
                switchOff();
                me.addClass('current');

                setTimeout(function () {
                    let offset = tgt.offset().top - panelwrap.outerHeight()
                    $('body, html').stop().animate({
                        scrollTop: offset
                    }, 1000, 'easeInOutExpo', function () {
                        self.state.scrolling = false;
                    });
                }, 100);
            });
        },

        goTop: function (callback) {
            $('body, html').stop().animate({
                scrollTop: 0
            }, callback);
        },

        toggleBurger: function() {
            let burger = $('.pageHeader .js-toggle-nav');
            let langnav = $('.pageHeader .langNav');
            let timer = null;

            burger.on('click', () => {
                if (this.ui.b.hasClass('is-navexpanded')) {
                    this.ui.b.removeClass('is-navexpanded');
                } else {
                    this.ui.b.addClass('is-navexpanded');
                }
            });

            if (window.ismobile) {
                langnav.on('click', 'button', () => {
                    this.ui.b.toggleClass('is-langexpanded');
                });
            } else {
                langnav.on('mouseenter', () => {
                    clearTimeout(timer);
                    timer = setTimeout(() => {
                        this.ui.b.addClass('is-langexpanded');
                    }, 250);
                });

                langnav.on('mouseleave', () => {
                    clearTimeout(timer);
                    this.ui.b.removeClass('is-langexpanded')
                });
            }
        },

        headerSlides: function () {
            if (! window._amc_headerslider) return;

            let timeout = 10000;
            if (window._amc_settings.slides_autoplay) {
                timeout = window._amc_settings.slides_autoplay * 1000;
            }

            $('.headerSlider .owl-carousel').owlCarousel({
                items: 1,
                nav: false,
                dots: true,
                dotsContainer: '.headerSlider__dots',
                autoplay: true,
                autoplaySpeed: 500,
                autoplayTimeout: timeout,
                loop: true
            });
        },

        cookies: function() {
            let accepted = Cookies.get('amccookies');
            if (accepted) return;

            let cookieDiv = $('#cookie-notice'),
                cookieBtn = $('#set-cookie-button');

            cookieDiv.fadeIn(250);
            cookieBtn.on('click', function(e) {
                e.preventDefault();

                Cookies.set('amccookies', '1', { expires: 30 });
                cookieDiv.fadeOut(250);
            });
        },

        solutions: function () {
            if (! window._amc_section_solutions) return;

            $('.solutions').each(function () {
                new AMC_Solutions($(this));
            });
        },

        stepsbox: function () {
            if (! window._amc_stepsbox) return;

            function doIt(el) {
                let steps = el.find('.stepsbox');

                steps.on('click mouseenter', function () {
                    steps.removeClass('active');
                    $(this).addClass('active');
                });
            }

            $('.stepsboxes').each(function() {
                doIt($(this));
            });
        },

        offercircle: function () {
            if (! window._amc_offercircle) return;

            $('.offercircle').each(function () {
                new AMC_Offercircle($(this));
            });
        },

        postscarousel: function () {
            if (! window._amc_postscarousel) return;

            $('.postscarousel').owlCarousel({
                dots: false,
                nav: true,
                navText: ['<i class="icon-button-arrow">', '<i class="icon-button-arrow">'],
                responsive: {
                    320: {
                        items: 1
                    },
                    600: {
                        items: 2
                    },
                    992: {
                        items: 3
                    },
                    1200: {
                        items: 4
                    }
                }
            });
        },

        jobs: function() {
            let self = this;
            if (! window._amc_jobslist) return;

            $('.joboffer').on('click', 'header', function (e) {
                e.preventDefault();

                let me = $(this).parents('.joboffer');
                if (me.hasClass('is-expanded')) {
                    me.removeClass('is-expanded');
                    me.find('.joboffer__content').stop().slideUp();
                } else {
                    me.addClass('is-expanded');
                    me.find('.joboffer__content').stop().slideDown();
                }
            });
        },

        gmap: function () {
            $('.map').each(function () {
                new GMap($(this));
            });
        },

        pswpGallery: function () {
            $('.js-pswp').each(function () {
                new AMC_PSWP($(this));
            });
        },

        formats: function () {
            $('span[class^="amcfs"]').each(function () {
                let me = $(this);
                console.log(me.parent().prop('tagName'));
                if (me.parent().prop('tagName') == 'LI') {
                    let cls = me.attr('class');
                    me.removeAttr('class');
                    me.parent().parent().addClass(cls);
                }
            });
        },

        debug: function() {
            let d = $('#debug');
            if (! d.length) return;

            d.html(window.innerWidth + ' x ' + window.innerHeight + ' px');
            $(window).on('resize', function () {
                d.html(window.innerWidth + ' x ' + window.innerHeight + ' px');
            });
        },

        lazyload: function () {
            $('img.lazyload').each(function () {
                let me = $(this);
                me.attr('src', me.attr('data-src'));
            })
        },

        gtm: function () {
            function loadgtm(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            '//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);console.log('gtm');
            };

            if (window._amc_settings.gtm) {
                console.log('load gtm');
                setTimeout(function() {
                    loadgtm(window,document,'script','dataLayer',window._amc_settings.gtm);
                }, 2000);
            }
        },

        init: function() {
            const ismobile = this.mobileCheck();
            let self = this;
            
            window.ismobile = ismobile;
            if (ismobile) {
                this.ui.b.addClass('is-mobile');
            } else {
                this.ui.b.addClass('is-desktop');
            }

            if (navigator.userAgent.match(/Webkit/i)) {
                this.ui.b.addClass('is-webkit');
            }

            this.toggleBurger();
            this.header();
            this.nav();
            this.localmenu();
            this.imitLocalmenu();
            this.drawer();
            this.solutions();
            this.headerSlides();
            this.stepsbox();
            this.offercircle();
            this.postscarousel();
            this.jobs();
            this.gmap();
            this.pswpGallery();
            this.formats();
            this.cookies();
            this.debug();

            $(window).on('load', function () {
                self.lazyload();
                // self.gtm();
            });
        }
    }


    $(document).ready(() => {
        App.init();
    });


    class AMC_PSWP {
        constructor(container) {
            let self = this;
            this.thumbs = container;
            this.pspwSlides = window[container.data('pswp')];
            this.pswpElement = $('.pswp').get(0);
            this.carousel = null;
            this.currentIndex = 0;
            this.init();
        }

        init() {
            let self = this;

            this.thumbs.on('click', '.pswp-item', function(e) {
                let me = $(this);
                let options = {
                    index: $(this).data('index'),
                    showHideOpacity: true,
                    history: false,
                    getThumbBoundsFn: function(index) {
                        var thumbnail = me.get(0), // find thumbnail
                            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                            rect = thumbnail.getBoundingClientRect();

                        return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
                    }
                };
                let gallery = new PhotoSwipe( self.pswpElement, PhotoSwipeUI_Default, self.pspwSlides, options);

                gallery.listen('gettingData', function (index, item) {
                    if (item.w < 1 || item.h < 1) {
                        var img = new Image();
                        img.onload = function () {
                            item.w = this.width;
                            item.h = this.height;
                            gallery.updateSize(true);
                        };
                        img.src = item.src;
                    }
                });

                gallery.init();
            });
        }
    };
})(jQuery);


